import { createContext, type ReactNode, useContext, useMemo } from "react";

import { FETCH_CUSTOM_GOALS } from "@gql/creative-analytics";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type FetchCustomGoals,
  type FetchCustomGoals_me_customGoals_goals,
} from "@north-beam/nb-client-side";

export interface CustomGoalsContextDescriptor {
  customGoals: FetchCustomGoals_me_customGoals_goals[];
  loading: boolean;
}

const CustomGoalsContext = createContext<CustomGoalsContextDescriptor>({
  customGoals: [],
  loading: false,
});

export const useCustomGoalsContext = () => {
  const context = useContext(CustomGoalsContext);

  if (!context) {
    throw new Error("useCustomGoals must be used within a CustomGoalsProvider");
  }

  return context;
};

export const CustomGoalsProvider = ({ children }: { children: ReactNode }) => {
  const { data, loading } =
    useNorthbeamQuery<FetchCustomGoals>(FETCH_CUSTOM_GOALS);

  const customGoals = useMemo(
    () => data?.me.customGoals.goals ?? [],
    [data?.me.customGoals],
  );

  return (
    <CustomGoalsContext.Provider value={{ customGoals, loading }}>
      {children}
    </CustomGoalsContext.Provider>
  );
};
